import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Main, Loading, Axios, Modal, usePaginacion, useModal, Paginacion, Swal } from '../../../Helpers/importacionesComunes'
import { useContextoGlobal } from '../../../Context/contextoGlobal';
import { Tabla } from '../componentes/Tabla';
import { Cabecera } from '../componentes/Cabecera';
import { obtenerFechaDiamenosN } from '../../../Helpers/fechas'
import { Button, Card, Dialog, DialogBody, DialogFooter, DialogHeader, List, ListItem, Spinner, Typography } from '@material-tailwind/react';
import { Divider } from '@mui/material';

const AUTO_REGION_ASSIGNMENT_ENABLED = false

const obtenerValoresInicialesFiltros = () => ({
    id_cuenta_bancaria: 1,
    id_region: null,
    estado: null,
    fecha_desde: obtenerFechaDiamenosN(365).date,
    fecha_hasta: new Date(),
})

const normalizarTexto = (valor) => String(valor || '').trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')

const esInterdepositoAnonimo = (item) => normalizarTexto(item?.estado) === 'anonimo'

const tieneRegionAsignada = (item) => {
    const idRegion = Number(item?.id_region || 0)
    const nombreRegion = normalizarTexto(item?.region || item?.nombre_region)

    if (idRegion > 0) {
        return true
    }

    return nombreRegion !== '' && nombreRegion !== 'sin region'
}

const puedeEditarInterdeposito = (item) => esInterdepositoAnonimo(item) || !tieneRegionAsignada(item)

export default function Interdepositos({ match, history }) {
    const [registros, setRegistros] = useState([])
    const [registrosAmostrar, setRegistrosAmostrar] = useState([])
    const [cargandoRegistros, setCargandoRegistros] = useState(true);
    const { esCelular, usuario } = useContextoGlobal();
    const [hayFiltrosActivos, setHayFiltrosActivos] = useState(false)
    const [huboError, setHuboError] = useState(false)
    const filtrosRef = useRef()
    const requestIdRef = useRef(0)
    const verificacionEnCursoRef = useRef(false)
    const [registroEditando, setRegistroEditando] = useState(null)
    const [claveRegistroEditando, setClaveRegistroEditando] = useState('')
    const [formularioEdicion, setFormularioEdicion] = useState(null)
    const [guardandoEdicion, setGuardandoEdicion] = useState(false)
    const [dataValues, setDataValues] = useState(obtenerValoresInicialesFiltros());

    const [regiones, setRegiones] = useState([]);
    const [cuentas, setCuentas] = useState([]);
    const [bancos, setBancos] = useState([]);
    const [distritos, setDistritos] = useState([]);
    const [verificandoRegiones, setVerificandoRegiones] = useState(false);

    const obtenerMensajeError = (err, fallbackMessage) => {
        const backendMessage = err?.response?.data?.message || err?.response?.data?.mensaje || err?.response?.data?.error

        if (typeof backendMessage === 'string' && backendMessage.trim() !== '') {
            return backendMessage.trim()
        }

        if (typeof err?.message === 'string' && err.message.trim() !== '') {
            return err.message.trim()
        }

        return fallbackMessage
    }

    const obtenerTituloMensaje = (type) => {
        switch (type) {
            case 'success':
                return 'Okey'
            case 'warning':
                return 'Atención'
            case 'error':
                return 'Error'
            default:
                return 'Información'
        }
    }

    const mostrarMensaje = (message, type = 'info') => {
        Swal.fire(obtenerTituloMensaje(type), message, type)
    }

    const mostrarErrorPeticion = (title, err, fallbackMessage) => {
        const detalle = obtenerMensajeError(err, fallbackMessage)
        mostrarMensaje(title ? `${title}. ${detalle}` : detalle, 'error')
    }

    useEffect(() => {
        const buscarRegiones = async () => {
            try {
                setCargandoRegistros(true)
                const resultado = await Axios.get('/api/tablasgenerales/regiones/*')
                setRegiones(resultado.data.filter(item => item.id_region > 0))
                setCargandoRegistros(false)
            } catch (err) {
                mostrarErrorPeticion('No se pudieron cargar las regiones', err, 'Ocurrió un error al cargar las regiones.')
                setCargandoRegistros(false)
            }
        }

        const buscarDistritos = async () => {
            try {
                const resultado = await Axios.get('/api/tablasgenerales/distritos/*')
                setDistritos(resultado.data.filter(item => item.id_distrito > 0))
            } catch (err) {
                console.log(err)
                mostrarErrorPeticion('No se pudieron cargar los distritos', err, 'Ocurrió un error al cargar los distritos.')
            }
        }

        if (usuario.sede_admin) {
            buscarRegiones()
        }
        buscarDistritos()
        buscarBancos();
        buscarCuentasBancarias();
    }, [])

    useEffect(() => {
        buscarDatos({ conLoading: true })
    }, [usuario]) // agregué usuario porque necesito que se dispare el evento cuando no sea vacío usuario, al principio es vacío por unos milisegundos...

    useEffect(() => {

        if (registrosAmostrar.length != registros.length) {
            setHayFiltrosActivos(true)
        } else {
            setHayFiltrosActivos(false)
        }

    }, [registrosAmostrar])

    const buscarCuentasBancarias = async () => {
        try {
            const resultado = await Axios.get('/api/tablasgenerales/banco/cuentas')
            setCuentas(resultado.data)
        } catch (err) {
            mostrarErrorPeticion('No se pudieron cargar las cuentas', err, 'Ocurrió un error al cargar las cuentas bancarias.')
        }
    }

    const buscarBancos = async () => {
        try {
            const resultado = await Axios.get('/api/tablasgenerales/bancos')
            setBancos(resultado.data?.recordset || resultado.data || [])
        } catch (err) {
            console.log(err)
            mostrarErrorPeticion('No se pudieron cargar los bancos', err, 'Ocurrió un error al cargar los bancos.')
        }
    }

    const handleChangeSelectRegion = (e) => {
        handleDataChanges(e, 'id_region');
    }

    const handleDataChanges = (value, type) => {
        setDataValues({ ...dataValues, [type]: value });
    }

    const aplicarFiltrosActivos = (data) => {
        if (typeof filtrosRef.current === 'function') {
            return data.filter(filtrosRef.current)
        }

        return data
    }

    const obtenerClaveInterdeposito = (item) => {
        if (!item) {
            return ''
        }

        return String(
            item.id_interdeposito ||
            item.id_interdep ||
            item.id ||
            [item.fecha, item.cod_operativo, item.referencia, item.suc_origen, item.importe_pesos].join('|')
        )
    }

    const formatearImporteParaEdicion = (valor) => {
        if (valor == null || valor === '') {
            return ''
        }

        if (typeof valor === 'number') {
            return valor.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        }

        return String(valor)
    }

    const normalizarImporteEditado = (valor) => {
        if (typeof valor === 'number') {
            return valor
        }

        if (!valor) {
            return 0
        }

        const valorNormalizado = String(valor).trim().replace(/\./g, '').replace(',', '.')
        const numero = Number(valorNormalizado)

        return Number.isNaN(numero) ? 0 : numero
    }

    const obtenerNombreCuenta = (idCuenta) => {
        const cuentaSeleccionada = cuentas.find((item) => Number(item.id_cuenta_bancaria) === Number(idCuenta))
        return cuentaSeleccionada?.descripcion || ''
    }

    const obtenerCuentaBancaria = (idCuenta) => {
        return cuentas.find((item) => Number(item.id_cuenta_bancaria) === Number(idCuenta)) || null
    }

    const obtenerNombreBanco = (idBanco) => {
        const bancoSeleccionado = bancos.find((item) => Number(item.id_banco || item.id) === Number(idBanco))
        return bancoSeleccionado?.nombre || ''
    }

    const obtenerIdMovCtaDep = (item) => {
        const idMovimiento = item?.id_mov_cta_dep ?? item?.id_mov_cta

        if (!idMovimiento) {
            return null
        }

        return Number(idMovimiento)
    }

    const crearFormularioEdicion = useCallback((item) => {
        const idCuentaBancaria = item.id_cuenta_bancaria || dataValues.id_cuenta_bancaria || ''
        const cuentaSeleccionada = obtenerCuentaBancaria(idCuentaBancaria)
        const idBanco = item.id_banco || cuentaSeleccionada?.id_banco || ''

        return {
            fecha: item.fecha || '',
            cod_operativo: item.cod_operativo || '',
            referencia: item.referencia || '',
            importe_pesos: formatearImporteParaEdicion(item.importe_pesos),
            concepto: item.concepto || '',
            estado: item.estado || '',
            banco: obtenerNombreBanco(idBanco) || item.banco || item.desc_banco || obtenerNombreCuenta(idCuentaBancaria),
            suc_origen: item.suc_origen != null ? String(item.suc_origen) : '',
            descripcion: item.descripcion || '',
            desc_sucursal: item.desc_sucursal || item.descripcion || '',
            localidad: item.localidad || '',
            id_region: item.id_region || (usuario?.sede_admin ? dataValues.id_region : usuario?.id_region) || '',
            id_distrito: item.id_distrito || '',
            id_cuenta_bancaria: idCuentaBancaria,
            id_banco: idBanco,
        }
    }, [bancos, cuentas, dataValues.id_cuenta_bancaria, dataValues.id_region, usuario?.id_region, usuario?.sede_admin])

    const abrirEditorInterdeposito = useCallback((item) => {
        if (!puedeEditarInterdeposito(item)) {
            mostrarMensaje('Solo se pueden editar interdepósitos anónimos o sin región.', 'warning')
            return
        }

        setRegistroEditando(item)
        setClaveRegistroEditando(obtenerClaveInterdeposito(item))
        setFormularioEdicion(crearFormularioEdicion(item))
    }, [crearFormularioEdicion, mostrarMensaje])

    const cerrarEditorInterdeposito = () => {
        setRegistroEditando(null)
        setClaveRegistroEditando('')
        setFormularioEdicion(null)
    }

    const handleFormularioEdicionChange = (campo, valor) => {
        setFormularioEdicion((prev) => ({
            ...prev,
            ...(campo === 'id_region' ? { id_distrito: '' } : {}),
            [campo]: valor,
        }))
    }

    const actualizarRegistrosEditados = (registroActualizado) => {
        const registrosActualizados = registros.map((item) => (
            obtenerClaveInterdeposito(item) === claveRegistroEditando ? registroActualizado : item
        ))

        setRegistros(registrosActualizados)
        setRegistrosAmostrar(aplicarFiltrosActivos(registrosActualizados))
    }

    const quitarRegistroDeListas = (registroEliminado) => {
        const claveEliminada = obtenerClaveInterdeposito(registroEliminado)
        const registrosActualizados = registros.filter((item) => obtenerClaveInterdeposito(item) !== claveEliminada)

        setRegistros(registrosActualizados)
        setRegistrosAmostrar(aplicarFiltrosActivos(registrosActualizados))
    }

    const huboCambiosEnSucursal = (registroActualizado) => {
        if (!registroEditando) {
            return false
        }

        return (
            Number(registroActualizado.id_region || 0) !== Number(registroEditando.id_region || 0) ||
            Number(registroActualizado.id_distrito || 0) !== Number(registroEditando.id_distrito || 0) ||
            Number(registroActualizado.id_banco || 0) !== Number(registroEditando.id_banco || 0) ||
            String(registroActualizado.suc_origen || '').trim() !== String(registroEditando.suc_origen || '').trim() ||
            String(registroActualizado.descripcion || '').trim() !== String(registroEditando.descripcion || registroEditando.desc_sucursal || '').trim() ||
            String(registroActualizado.localidad || '').trim() !== String(registroEditando.localidad || '').trim()
        )
    }

    const ejecutarGuardadoEdicion = async () => {
        if (!registroEditando || !formularioEdicion || guardandoEdicion) {
            return
        }

        const regionSeleccionada = regiones.find((item) => Number(item.id_region) === Number(formularioEdicion.id_region))
        const registroActualizado = {
            ...registroEditando,
            ...formularioEdicion,
            descripcion: formularioEdicion.descripcion,
            desc_sucursal: formularioEdicion.desc_sucursal || registroEditando.desc_sucursal || '',
            suc_origen: formularioEdicion.suc_origen,
            id_region: formularioEdicion.id_region ? Number(formularioEdicion.id_region) : null,
            id_distrito: formularioEdicion.id_distrito ? Number(formularioEdicion.id_distrito) : null,
            id_cuenta_bancaria: formularioEdicion.id_cuenta_bancaria ? Number(formularioEdicion.id_cuenta_bancaria) : null,
            id_banco: formularioEdicion.id_banco ? Number(formularioEdicion.id_banco) : null,
            importe_pesos: normalizarImporteEditado(formularioEdicion.importe_pesos),
            nombre_region: regionSeleccionada?.nombre || registroEditando.nombre_region,
            region: regionSeleccionada?.nombre || registroEditando.region,
            banco: formularioEdicion.banco,
        }
        const requierePersistirSucursal = huboCambiosEnSucursal(registroActualizado)
        const payloadCambioRegion = requierePersistirSucursal
            ? obtenerPayloadCambioRegion(registroActualizado, usuario?.sede_admin ? dataValues.id_region : usuario?.id_region)
            : null

        if (requierePersistirSucursal && !payloadCambioRegion) {
            mostrarMensaje('Para guardar la sucursal bancaria completá región y nombre.', 'warning')
            return
        }

        setGuardandoEdicion(true)

        try {
            if (payloadCambioRegion) {
                await Axios.post('/api/tablasgenerales/interdepositos/cambiar-region', payloadCambioRegion)
            }

            cerrarEditorInterdeposito()
            const listaActualizada = await buscarDatos({ conLoading: false, skipAutoVerify: true, limpiarPrevio: false })
            if (listaActualizada !== false) {
                mostrarMensaje('La sucursal bancaria se actualizo correctamente.', 'success')
            }
        } catch (err) {
            console.log(err)
            mostrarErrorPeticion('No se pudieron guardar los cambios', err, 'No se pudieron guardar los cambios de la sucursal bancaria.')
        } finally {
            setGuardandoEdicion(false)
        }
    }

    const guardarCambiosEdicion = async () => {
        if (!registroEditando || !formularioEdicion || guardandoEdicion) {
            return
        }

        const resultado = await Swal.fire({
            title: '¿Guardar cambios? ',
            text: 'Se actualizará la sucursal bancaria del interdepósito.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, guardar',
            cancelButtonText: 'Cancelar'
        })

        if (!resultado.isConfirmed && !resultado.value) {
            return
        }

        await ejecutarGuardadoEdicion()
    }

    const eliminarInterdeposito = async (item) => {
        const idMovCtaDep = obtenerIdMovCtaDep(item)

        if (!idMovCtaDep) {
            mostrarMensaje('No se encontró el identificador del interdepósito a eliminar.', 'warning')
            return
        }

        const resultado = await Swal.fire({
            title: '¿Eliminar interdepósito?',
            text: 'Esta acción eliminará el interdepósito seleccionado.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        })

        if (!resultado.isConfirmed && !resultado.value) {
            return
        }

        try {
            await Axios.delete('/api/tablasgenerales/interdepositos/borrar', {
                data: {
                    id_mov_cta_dep: idMovCtaDep,
                }
            })

            if (obtenerClaveInterdeposito(item) === claveRegistroEditando) {
                cerrarEditorInterdeposito()
            }

            quitarRegistroDeListas(item)
            mostrarMensaje('El interdepósito se eliminó correctamente.', 'success')
        } catch (err) {
            console.log(err)
            mostrarErrorPeticion('No se pudo eliminar el interdepósito', err, 'Ocurrió un error al eliminar el interdepósito.')
        }
    }

    const obtenerPayloadCambioRegion = (item, idRegionBase) => {
        const idRegion = Number(item.id_region || idRegionBase)
        const idDistrito = item.id_distrito ? Number(item.id_distrito) : null
        const idBanco = item.id_banco ? Number(item.id_banco) : null
        const sucOrigen = item.suc_origen != null ? String(item.suc_origen).trim() : ''
        const descripcion = (item.descripcion || item.desc_sucursal || '').trim()
        const localidad = (item.localidad || '').trim()

        if (!idRegion || !sucOrigen) {
            return null
        }

        return {
            id_region: idRegion,
            id_distrito: idDistrito,
            id_banco: idBanco,
            suc_origen: sucOrigen,
            descripcion,
            localidad
        }
    }

    const verificarYAgregarRegionesAutomaticamente = async (data, idRegionBase) => {
        const payloadsUnicos = new Map()

        data
            .filter(item => !item.id_region)
            .forEach((item) => {
                const payload = obtenerPayloadCambioRegion(item, idRegionBase)
                if (!payload) {
                    return
                }

                const key = [payload.id_region, payload.id_distrito, payload.id_banco, payload.suc_origen, payload.descripcion, payload.localidad].join('|')
                if (!payloadsUnicos.has(key)) {
                    payloadsUnicos.set(key, payload)
                }
            })

        if (payloadsUnicos.size === 0) {
            return false
        }

        setVerificandoRegiones(true)
        try {
            await Promise.all(
                Array.from(payloadsUnicos.values()).map((payload) =>
                    Axios.post('/api/tablasgenerales/interdepositos/cambiar-region', payload)
                )
            )
            return true
        } catch (err) {
            console.log(err)
            mostrarErrorPeticion('No se pudieron actualizar las regiones', err, 'Ocurrió un error al actualizar las regiones faltantes.')
            return false
        } finally {
            setVerificandoRegiones(false)
        }
    }

    const refrescarLista = async (requestParams, requestId) => {
        const { data } = await Axios.post(`/api/tablasgenerales/interdepositos/lista`, requestParams)

        if (requestId !== requestIdRef.current) {
            return
        }

        setRegistros(data)
        setRegistrosAmostrar(aplicarFiltrosActivos(data))
    }

    const iniciarVerificacionEnSegundoPlano = async (data, requestParams, requestId) => {
        if (verificacionEnCursoRef.current) {
            return
        }

        verificacionEnCursoRef.current = true
        setVerificandoRegiones(true)

        try {
            const huboCambiosAutomaticos = await verificarYAgregarRegionesAutomaticamente(data, requestParams.id_region)
            if (huboCambiosAutomaticos) {
                await refrescarLista(requestParams, requestId)
            }
        } finally {
            verificacionEnCursoRef.current = false
            setVerificandoRegiones(false)
        }
    }

    const buscarDatos = async (params = {}) => {
        const { conLoading, skipAutoVerify = false, limpiarPrevio = true, valores } = params // con loading se usa para la búsqueda inicial de registros
        // Cuando se modificó una iglesia queremos mantener el modal abierto y no mostramos el loading
        const valoresActuales = valores || dataValues

        setHuboError(false)
        if (limpiarPrevio) {
            setRegistros([])
        }
        conLoading && setCargandoRegistros(true)
        try {
            const requestId = requestIdRef.current + 1
            requestIdRef.current = requestId
            const requestParams = {
                ...valoresActuales,
                id_region: usuario.sede_admin ? valoresActuales.id_region : usuario.id_region
            }
            const { data } = await Axios.post(`/api/tablasgenerales/interdepositos/lista`, requestParams)

            if (requestId !== requestIdRef.current) {
                return
            }

            setRegistros(data)
            setRegistrosAmostrar(aplicarFiltrosActivos(data))
            setCargandoRegistros(false)

            if (!skipAutoVerify && AUTO_REGION_ASSIGNMENT_ENABLED) {
                void iniciarVerificacionEnSegundoPlano(data, requestParams, requestId)
            }

            return true
        } catch (err) {
            console.log(err)
            setHuboError(true)
            setCargandoRegistros(false)
            mostrarErrorPeticion('No se pudieron cargar los interdepósitos', err, 'Ocurrió un error al cargar los registros.')
            return false
        }
    }

    const filtrarLista = (filterCallback) => {
        buscarDatos({ conLoading: true })

        let vectorRegistrosOriginalFiltrado;

        vectorRegistrosOriginalFiltrado = registros.filter(filterCallback)

        filtrosRef.current = filterCallback

        setRegistrosAmostrar(vectorRegistrosOriginalFiltrado)

    }

    const limpiarFiltros = () => {
        const valoresIniciales = obtenerValoresInicialesFiltros()
        setDataValues(valoresIniciales)
        filtrosRef.current = null
        buscarDatos({ conLoading: true, valores: valoresIniciales })
    }

    /*if (usuario.sede_admin){
        return <Main center><span>Esta vista está disponible solo para el perfil de secretaría regional</span></Main>
    }*/


    /*
    if(usuario.sede_admin && !regionSeleccionada){
        return <SolicitarRegion usuario={usuario} 
                regionSeleccionada={regionSeleccionada} 
                setRegionSeleccionada={setRegionSeleccionada}/>
    }*/

    if (huboError) {
        return <Main center>
            <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)]'>
                <span>Se produjo un error al cargar los datos para esta vista</span>
            </div>
        </Main>
    }

    if (cargandoRegistros || !usuario) {
        return <Main center alinear>
            <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)]'>
                <Spinner className="h-12 w-12" />
                <span className="cargando font-semibold text-[15px]">{verificandoRegiones ? 'Verificando regiones...' : 'Cargando registros...'}</span>
            </div>
        </Main>
    };

    const filtrosActivos = (() => {
        const valoresIniciales = obtenerValoresInicialesFiltros()
        const esMismaFecha = (a, b) => {
            const fechaA = a instanceof Date ? a : new Date(a)
            const fechaB = b instanceof Date ? b : new Date(b)
            return fechaA.toDateString() === fechaB.toDateString()
        }

        return (
            (dataValues.estado ?? null) !== null ||
            (dataValues.id_region ?? null) !== null ||
            Number(dataValues.id_cuenta_bancaria) !== Number(valoresIniciales.id_cuenta_bancaria) ||
            !esMismaFecha(dataValues.fecha_desde, valoresIniciales.fecha_desde) ||
            !esMismaFecha(dataValues.fecha_hasta, valoresIniciales.fecha_hasta)
        )
    })()

    return (
        <Card className='w-full lg:!m-6 xl:!m-6'>
            <div className="bg-blue text-whitexxx p-4 rounded ml-auto mr-auto mb-4 w-full">
                <Typography variant="h5" className="w-full mb-2 flex justify-center lg:hidden xl:hidden">
                    Depósitos sin identificar
                </Typography>
                <div className='mb-2'>
                    <Cabecera
                        filtrarLista={filtrarLista}   // el listado se filtra y se resetea en el comp padre porque los datos se comparten con otros componentes
                        limpiarFiltros={limpiarFiltros}
                        filtrosActivos={filtrosActivos}
                        hayFiltrosActivos={hayFiltrosActivos}
                        usuario={usuario}
                        regiones={regiones}
                        cuentas={cuentas}
                        handleDataChanges={handleDataChanges}
                        handleChangeSelectRegion={handleChangeSelectRegion}
                        dataValues={dataValues}
                    />
                </div>


                {esCelular && <TablaMobile registrosAmostrar={registrosAmostrar} onEditarRegistro={abrirEditorInterdeposito} onEliminarRegistro={eliminarInterdeposito} puedeEditarRegistro={puedeEditarInterdeposito} />}

                {!esCelular && <Tabla
                    registrosAmostrar={registrosAmostrar}
                    onEditarRegistro={abrirEditorInterdeposito}
                    onEliminarRegistro={eliminarInterdeposito}
                    puedeEditarRegistro={puedeEditarInterdeposito}
                />}
            </div>
            <EditorInterdepositoDialog
                open={!!registroEditando}
                registro={registroEditando}
                formulario={formularioEdicion}
                cuentas={cuentas}
                bancos={bancos}
                distritos={distritos}
                regiones={regiones}
                guardando={guardandoEdicion}
                puedeEditarRegion={!!usuario?.sede_admin}
                onChange={handleFormularioEdicionChange}
                onClose={cerrarEditorInterdeposito}
                onSave={guardarCambiosEdicion}
            />
        </Card>)
}

const convertirFormato = (numero) => {
    // Reemplaza la coma por un punto
    let numeroConPunto = numero.replace(/,/g, '.');
    // Reemplaza el punto (de los decimales) por una coma
    let numeroEnNuevoFormato = numeroConPunto.replace(/\.(?=[^.]*$)/, ',');
    return numeroEnNuevoFormato;
}

const formatearImporte = (numero) => {
    return numero.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function TablaMobile({ registrosAmostrar, onEditarRegistro, onEliminarRegistro, puedeEditarRegistro = () => true }) {

    return <Card className='mt-2'>
        <List>
            {registrosAmostrar.map((item, index) =>
                <>
                    <ListItem key={index}>
                        <div className='f-col space-y-2 w-full'>
                            <p><span className='font-bold'>Fecha: </span>{item.fecha}</p>
                            <p><span className='font-bold'>Banco: </span>{item.desc_sucursal}</p>
                            <p><span className='font-bold'>Región: </span>{item.region || item.nombre_region || item.id_region || 'Sin región'}</p>
                            <p><span className='font-bold'>Concepto: </span>{item.concepto}</p>
                            <p><span className='font-bold'>Importe: </span>{formatearImporte(item.importe_pesos || 0)}</p>
                            <div className='pt-2'>
                                <div className='flex flex-wrap gap-2'>
                                    {puedeEditarRegistro(item) && <Button
                                        size='sm'
                                        variant='outlined'
                                        className='rounded-lg border-blue-gray-200 text-blue-gray-700 hover:bg-blue-gray-50'
                                        onClick={() => onEditarRegistro(item)}
                                    >
                                        Ver y editar
                                    </Button>}
                                    <Button
                                        size='sm'
                                        variant='outlined'
                                        color='red'
                                        className='rounded-lg'
                                        onClick={() => onEliminarRegistro(item)}
                                    >
                                        Eliminar
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </ListItem>
                    <Divider />
                </>
            )}
        </List>
    </Card>
}

function buscarApi(usuario, regionSeleccionada) {
    if (usuario.sede_admin) {
        if (!regionSeleccionada) {
            return null
        }
        return `/api/tablasgenerales/interdepositos/${regionSeleccionada}`;
    } else {
        return `/api/tablasgenerales/interdepositos/${usuario.id_region}`;
    }
}

function EditorInterdepositoDialog({ open, registro, formulario, cuentas, bancos, distritos, regiones, guardando, puedeEditarRegion, onChange, onClose, onSave }) {
    if (!registro || !formulario) {
        return null
    }
    console.log("bancos", bancos);
    const cuentaSeleccionada = cuentas.find((item) => Number(item.id_cuenta_bancaria) === Number(formulario.id_cuenta_bancaria))
    const idBancoSeleccionado = formulario.id_banco || cuentaSeleccionada?.id_banco || ''
    const nombreBanco = bancos.find((item) => Number(item.id_banco || item.id) === Number(idBancoSeleccionado))?.nombre || formulario.banco || ''
    const numeroSucursal = String(formulario.suc_origen || '')
    const distritosDeRegion = distritos
        .filter((item) => item.id_distrito > 0)
        .filter((item) => Number(item.id_region) === Number(formulario.id_region))

    return (
        <Dialog open={open} handler={onClose} size="xl">
            <DialogHeader className="border-b border-slate-200">Detalle del interdepósito</DialogHeader>
            <DialogBody className="max-h-[75vh] overflow-y-auto">
                <div className="grid gap-6 lg:grid-cols-2">
                    <section className="rounded-xl border border-slate-200 bg-slate-50 p-4">
                        <Typography variant="h6" color="blue-gray" className="mb-4">
                            Datos del interdepósito
                        </Typography>
                        <div className="grid gap-4 md:grid-cols-2">
                            <CampoEditable label="Fecha">
                                <input className="w-full rounded-lg border border-slate-300 bg-slate-100 px-3 py-2 text-sm" value={formulario.fecha} disabled />
                            </CampoEditable>
                            <CampoEditable label="Cód. Op.">
                                <input className="w-full rounded-lg border border-slate-300 bg-slate-100 px-3 py-2 text-sm" value={formulario.cod_operativo} disabled />
                            </CampoEditable>
                            <CampoEditable label="Referencia">
                                <input className="w-full rounded-lg border border-slate-300 bg-slate-100 px-3 py-2 text-sm" value={formulario.referencia} disabled />
                            </CampoEditable>
                            <CampoEditable label="Monto">
                                <input className="w-full rounded-lg border border-slate-300 bg-slate-100 px-3 py-2 text-sm" value={formulario.importe_pesos} disabled />
                            </CampoEditable>
                            <CampoEditable label="Estado">
                                <input className="w-full rounded-lg border border-slate-300 bg-slate-100 px-3 py-2 text-sm" value={formulario.estado} disabled />
                            </CampoEditable>
                            <div />
                            <CampoEditable label="Concepto" className="md:col-span-2">
                                <textarea className="min-h-[120px] w-full rounded-lg border border-slate-300 bg-slate-100 px-3 py-2 text-sm" value={formulario.concepto} disabled />
                            </CampoEditable>
                        </div>
                    </section>

                    <section className="rounded-xl border border-slate-200 bg-white p-4">
                        <Typography variant="h6" color="blue-gray" className="mb-4">
                            Sucursal bancaria
                        </Typography>
                        <div className="grid gap-4 md:grid-cols-2">
                            <CampoEditable label="Banco">
                                <input className="w-full rounded-lg border border-slate-300 bg-slate-100 px-3 py-2 text-sm" value={nombreBanco} disabled />
                            </CampoEditable>
                            <CampoEditable label="Sucursal">
                                <input className="w-full rounded-lg border border-slate-300 bg-slate-100 px-3 py-2 text-sm" value={numeroSucursal} disabled />
                            </CampoEditable>
                            <CampoEditable label="Nombre" className="md:col-span-2">
                                <input className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm" value={formulario.descripcion || ''} onChange={(e) => onChange('descripcion', e.target.value)} />
                            </CampoEditable>
                            <CampoEditable label="Localidad" className="md:col-span-2">
                                <input className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm" value={formulario.localidad} onChange={(e) => onChange('localidad', e.target.value)} />
                            </CampoEditable>
                            <CampoEditable label="Región">
                                {puedeEditarRegion ? (
                                    <select className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm" value={formulario.id_region} onChange={(e) => onChange('id_region', e.target.value)}>
                                        <option value="">Seleccione una región</option>
                                        {regiones.map((item) => (
                                            <option key={item.id_region} value={item.id_region}>{item.nombre}</option>
                                        ))}
                                    </select>
                                ) : (
                                    <input className="w-full rounded-lg border border-slate-300 bg-slate-100 px-3 py-2 text-sm" value={registro.region || registro.nombre_region || formulario.id_region || ''} disabled />
                                )}
                            </CampoEditable>
                            <CampoEditable label="Distrito">
                                <select className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm" value={formulario.id_distrito || ''} onChange={(e) => onChange('id_distrito', e.target.value)} disabled={!formulario.id_region}>
                                    <option value="">Seleccione un distrito</option>
                                    {distritosDeRegion.map((item) => (
                                        <option key={item.id_distrito_region || item.id_distrito} value={item.id_distrito}>{item.nombre}</option>
                                    ))}
                                </select>
                            </CampoEditable>
                        </div>
                    </section>
                </div>
            </DialogBody>
            <DialogFooter className="space-x-2 border-t border-slate-200">
                <Button variant="text" color="blue-gray" onClick={onClose} disabled={guardando}>Cancelar</Button>
                <Button color="blue" onClick={onSave} disabled={guardando}>{guardando ? 'Guardando...' : 'Guardar cambios'}</Button>
            </DialogFooter>
        </Dialog>
    )
}

function CampoEditable({ label, className = '', children }) {
    return (
        <div className={className}>
            <label className="mb-1 block text-sm font-semibold text-slate-700">{label}</label>
            {children}
        </div>
    )
}

